<template>
    <div id="order">
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />
        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden; position: relative">
            <userLeft :active="12" />
            <div class="box5" style="position: relative">
                <div style="overflow: hidden; position: relative; height: 60px">
                    <div class="box61" style="float: left; margin-top: 40px;margin-bottom: 20px;">我的订单</div>
                    <a-input-search class="search" placeholder="输入订单编号/商品货号/名称查询 " enter-button="查询" @search="onSearch" v-model="search" />
                    <a-select class="select-shop" default-value="全部店铺" @change="dindan_handleChange">
                        <a-select-option :value="item1.uuid" style="" v-for="(item1, index) in storelist" :key="index">
                            {{ item1.name }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 4%">
                    <div :class="['head_items', order_active_index == index ? 'active' : '']" @click="chang_order_state(index)" style="position: relative" v-for="(item, index) in top_navs" :key="index">
                        <div>
                            {{ item.txt }}<span v-show="item.count > 0"> {{ item.count }}</span>
                        </div>
                        <div v-if="order_active_index == index" style="width: 100%; height: 2px; background: #2b9a34; bottom: 0; left: 0; margin-top: 20px"></div>
                    </div>
                    <!-- <a-select default-value="全部订单" style="width: 100px; float: right;" @change="dindan_handleChange">
                    <a-select-option value="全部订单">
                      全部订单
                    </a-select-option>
                    <a-select-option value="可开票订单">
                      可开票订单
                    </a-select-option>
                  </a-select> -->
                </div>

                <div v-if="kaipiao_show == 0">
                    <div class="item-header">
                        <span>订单详情</span>
                        <span>单价</span>
                        <span>运费</span>
                        <!-- <span>付款金额</span> -->
                        <!-- <span>收货人</span> -->
                        <span>状态</span>
                        <span>操作</span>
                    </div>
                    <div v-for="(item, index) in order_list" style="overflow: hidden; margin-top: 20px" :key="index">
                        <!-- <div v-if="top_navs[order_active_index].status == 'COMPLETED'" style="width: 5%; height: 100%; overflow: hidden; float: left; margin-top: 60px">
                            <a-checkbox @change="item_kaipiao(index)"></a-checkbox>
                        </div> -->
                        <div :class="['order_box', top_navs[order_active_index].status == 'COMPLETED' ? 'left_order_active' : '']">
                            <div style="width: 96%; margin: auto; border-bottom: 1px solid #ede9e9; overflow: hidden; padding: 8px 0;">
                                <div class="order_item_title">
                                    <div class="display">
                                        <span style="width:180px">订单编号：{{ item.orderSn }}</span>
                                        <span style="width:60px;color:#FFF;height:19px;margin-right:5px;display: inline-block;background-color:red;text-align:center" v-if="item.returnBack === true">退换订单</span>
                                        <span style="width:200px">商家名称：{{ item.storeName }}</span>
                                        <span style="width:50px">{{ item.storeType == 'SELF' ? '自营' : '普通' }}</span>
                                        <span style="width:200px">仓库名称：{{ item.warehouseName }}</span>
                                        <span>{{ item.createdAt }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="item-content">
                                <div>
                                    <div class="goods_left_item item-goods" v-for="(_item, index) in item.ordersItemList" :key="index">
                                        <span @click="tiao(_item, index)" class="tiao">
                                            <img v-if="_item.cover" :src="`/api/file/preview/${_item.cover ? _item.cover : 'null'}`" alt="" style="width:50px;height:50px" />
                                            <img v-else src="../assets/pro-default-img@2x.png" alt="" style="width:50px;height:50px" />
                                        </span>
                                        <span>
                                            <span @click="tiao(_item, index)" class="tiao" style="width:100px;display:flex;flex-direction:column;align-items:center;">
                                                <span style="line-height:15px;margin:40px 0 0px 0" class="siderbarTitle">{{ _item.productName }}</span>
                                                <span v-if="_item.skuSn" style="line-height:30px">({{ _item.skuSn }})</span>
                                            </span>
                                        </span>

                                        <span class="siderbarTitle">{{ _item.specification }}</span>
                                        <span style="width:50px">x {{ item.returnBack?_item.afterSale.returnNum:_item.quantity }}</span>
                                        <span class="siderbarTitle">包装: {{ _item.packaging }}</span>
                                        <span>{{ _item.price | moneyStr }}</span>
                                        <span>{{ _item.freight | moneyStr }}</span>
                                    </div>
                                </div>
                                <div>
                                    <div>{{ item.orderStatus | orderStatusStr }}</div>
                                    <div class="order_item_title">
                                        <div class="querenshouh" v-if="item.orderStatus == 'PENDING_PAYMENT'" @click="dindancaozuo(item)">立即支付</div>
                                        <div class="querenshouh" v-if="item.orderStatus == 'SHIPPED'" @click="dindancaozuo(item)">确认收货</div>
                                        <div @click="zukf(item)">咨询客服</div>
                                        <!-- <div @click="to_order_details(item)">订单详情</div> -->
                                        <router-link target="_blank" :to="{ path: `/pay_to?uuid=${item.uuid}` }" style="color:#000;">订单详情</router-link>
                                        <p style="color:#000;margin-top:5px"><router-link target="_blank" :to="{ path: `refund_details?uuid=${item.uuid}` }" v-if="item.returnBack === true" style="color:#000">退换详情</router-link></p>
                                        <div v-if="item.orderStatus === 'COMPLETED' " @click="toRefund(item.uuid)">申请退货</div>
                                        <div v-if="item.orderStatus == 'COMPLETED' && item.invoiceOpen == false" @click="dindan_kaipiao(item)">申请开票</div>
                                        <div v-if="item.orderStatus == 'COMPLETED'" @click="dindan_shouhuo(item)">订单售后</div>
                                        <div v-if="item.invoiceOpen == true" @click="chakan_fapiao(item)">查看发票</div>
                                        <div v-if="item.orderStatus == 'PENDING_AUDIT' && item.returnBack === true" @click="quxiao_order(item)">取消订单</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div :class="['order_boxs', top_navs[order_active_index].status == 'COMPLETED' ? 'left_order_active' : '']">
                            <div style="margin:8px 20px">
                                <span style="margin-right:20px">收货人：{{ item.receiverBean.consignee }}</span>
                                <span>{{ item.receiverBean.phone }}</span>
                            </div>
                            <div style="margin:8px 20px" v-if="item.paymentMethodName">
                                <span>支付方式：{{ item.paymentMethodName }}</span>
                            </div>
                            <div style="margin:8px 20px">
                                <span>{{item.returnBack?'退款金额':'付款金额：'}}</span>
                                <span style="color: #f24145;">￥{{ item.orderAmount / 100 }}</span>
                                <span style="color: #666;">( 含运费 )</span>
                            </div>
                        </div>
                    </div>

                    <!-- <div style="width: 100%; margin: 5% auto; overflow: hidden;" v-if="top_navs[order_active_index].status == 'COMPLETED' && order_list.length > 0">
                        <div style="overflow: hidden; float: left;">
                        <a-checkbox @change="kaipiao_quanxuan(1)" style="float: left;">本页全选</a-checkbox>
                        <a-checkbox @change="kaipiao_quanxuan(0)" style="float: left; margin-left: 20px;">本页反选</a-checkbox>
                      </div>
                      <div @click="_kaipiao_xiayibu" class="kaipiao_xiayibu">下一步</div>
                    </div> -->

                    <div v-if="order_list.length == 0" style="margin-top: 40px; text-align: center">没有记录~</div>
                </div>

                <div v-if="kaipiao_show == 1">
                    <div style="width: 100%; height: 1px; border: 1px dashed #eeeeee; margin-top: 4%"></div>
                    <div style="overflow: hidden">
                        <div class="box6" style="margin-top: 4%; overflow: hidden">发票信息</div>
                        <div style="overflow: hidden; margin-top: 4%">
                            <div v-if="my_fapiao" @click="_invoice_information_index(0)" :class="['zengzhishui', invoice_information_index == 0 ? 'fapiao_actiive' : '']">增值税普通发票</div>
                            <div v-if="my_fapiao" @click="_invoice_information_index(1)" :class="['zengzhishui', invoice_information_index == 1 ? 'fapiao_actiive' : '']" style="margin-left: 4%">增值税专用发票</div>
                        </div>
                        <div v-if="invoice_information_index == 0 && my_fapiao.length > 0" style="width: 100%; height: 60px; background: #f4f4f4; margin-top: 4%; padding: 0 2%">
                            <div class="fapiaotaitou" v-if="my_fapiao[invoice_information_index].title">
                                发票抬头：{{ my_fapiao[invoice_information_index].title }} <span style="margin-left: 40%">统一社会信用代码：{{ my_fapiao[invoice_information_index].unifiedSocialCreditCode }}</span>
                            </div>
                        </div>

                        <div v-if="invoice_information_index == 1 && my_fapiao.length > 0" style="width: 100%; border: 1px solid #eeeeee; margin-top: 20px; padding-bottom: 20px">
                            <div style="overflow: hidden; margin-top: 20px; margin-left: 20px">
                                <div style="width: 50%; float: left" class="zengzhishui_txt">增值税专用发票</div>
                                <div style="width: 50%; float: left"></div>
                            </div>
                            <div style="overflow: hidden; margin-top: 20px; margin-left: 20px">
                                <div style="width: 50%; float: left" class="zengzhishui_txt" v-if="my_fapiao[invoice_information_index].title || my_fapiao[invoice_information_index].title">公司名称：{{ my_fapiao[invoice_information_index].title }}</div>
                                <div style="width: 50%; float: left">统一社会信用代码：{{ my_fapiao[invoice_information_index].unifiedSocialCreditCode }}</div>
                            </div>
                            <div style="overflow: hidden; margin-top: 20px; margin-left: 20px">
                                <div style="width: 50%; float: left" class="zengzhishui_txt">注册地址：{{ my_fapiao[invoice_information_index].registerAddress }}</div>
                                <div style="width: 50%; float: left">注册电话：{{ my_fapiao[invoice_information_index].registerTel }}</div>
                            </div>
                            <div style="overflow: hidden; margin-top: 20px; margin-left: 20px">
                                <div style="width: 50%; float: left" class="zengzhishui_txt">开户银行：{{ my_fapiao[invoice_information_index].bankName }}</div>
                                <div style="width: 50%; float: left">银行账号：{{ my_fapiao[invoice_information_index].bankAccount }}</div>
                            </div>
                            <!-- <div style="overflow: hidden; margin-top: 20px; margin-left: 20px">
                                <div style="width: 20%; float: left; margin-top: 20px" class="zengzhishui_txt">证书扫描件</div>
                                <div style="width: 50%; float: left">
                                    <img :src="'/api/file/preview/' + item" :key="index" v-for="(item, index) in my_fapiao[invoice_information_index].scanList" style="width: 80px; height: 84px; float: left; margin-left: 10px" alt="" />
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <div style="width: 100%; height: 1px; border: 1px dashed #eeeeee; margin-top: 4%"></div>
                    <div style="overflow: hidden">
                        <div class="box6" style="margin-top: 4%; overflow: hidden">收票方式</div>
                        <div style="overflow: hidden; margin-top: 4%">
                            <div v-if="invoice_information_index !== 1" @click="_ticket_collection_index(0)" :class="['zengzhishui', ticket_collection_index == 0 ? 'fapiao_actiive' : '']" style="margin-right: 20px;">电子发票</div>
                            <div v-if="invoice_information_index === 1" @click="_ticket_collection_index(1)" :class="['zengzhishui', ticket_collection_index == 1 ? 'fapiao_actiive' : '']">邮寄纸质发票</div>
                        </div>
                        <table v-show="fapiao_list_show" class="table-invoice">
                            <tr>
                                <td></td>
                                <td>姓名</td>
                                <td>手机</td>
                                <td>{{ ticket_collection_index ? '收货地址' : '' }}</td>
                                <td></td>
                            </tr>
                            <tr v-for="(item, index) in listInvoiceShow" :key="item.id" @click="checkInvoice(index)">
                                <td>
                                    <input type="radio" :checked="item.is_check" />
                                </td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.mobile }}</td>
                                <td>{{ item.address }}</td>
                                <td>
                                    <span v-if="item.defaults" class="active">默认{{ item.types == 'PAPER' ? '纸质发票' : '电子发票' }}</span>
                                    <span v-else @click="setInvoiceDefaul(index)">设为默认{{ item.types == 'PAPER' ? '纸质发票' : '电子发票' }}</span>
                                    <span @click="editInvoice(item.uuid)">编辑</span>
                                    <span @click="shanchu(item.uuid)">删除</span>
                                </td>
                            </tr>
                        </table>

                        <div @click="fapiao_list_show = !fapiao_list_show" class="shouqifapiao" style="overflow: hidden">
                            <span style="float: left">{{ fapiao_list_show ? '收起' : '展开' }}{{ ticket_collection_index == 1 ? '纸质' : '电子' }}发票</span>
                            <a-icon style="float: left; margin-top: 3px; margin-left: 10px" :type="fapiao_list_show ? 'up' : 'down'" />
                        </div>
                        <div style="margin-top: 20px">
                            <p class="fapiaoxiangqing_txt">发票详情</p>
                            <p class="fapiaoxiangqing_txt1">发票内容：{{ kaipiao_order[0].ordersItemList[0].productName }}</p>
                            <p class="fapiaoxiangqing_txt1">开票方：{{ kaipiao_order[0].storeName }}</p>
                            <p class="fapiaoxiangqing_txt1">
                                发票总金额：
                                <span style="color: #f24145; font-size: 18px">{{ kaipiao_order[0].orderAmount | moneyStr }}</span>
                            </p>
                        </div>
                        <div style="width: 100%; height: 1px; background: #eeeeee"></div>
                        <div @click="submitInvoice" class="tijiaofapiao">提交</div>
                    </div>
                </div>

                <div v-if="kaipiao_show == 2">
                    <div style="margin-top: 40px; margin-left: 65px">
                        <div style="overflow: hidden">
                            <img src="../assets/wangjimima_zhengque.png" style="width: 44px; height: 44px; float: left" alt="" />
                            <div class="kaipiaochengon_txt">提交成功</div>
                        </div>
                        <div style="margin-left: 30px; margin-top: 10px" class="kaipiaochengon_txt1">
                            <div style="margin-top: 40px">
                                <p>订单编号：{{ fapiao_res.orderSn }}</p>
                                <p>收货地址：{{ fapiao_res.name }} {{ fapiao_res.mobile }} {{ fapiao_res.address }}</p>
                            </div>

                            <p style="margin-top: 40px">
                                您可以 <span style="margin-left: 20px"><router-link style="color: #2b9a34" to="/billing_record">查看已开票记录</router-link> </span> <span style="margin-left: 20px"><router-link style="color: #2b9a34" :to="'/invoice_details?uuid=' + fapiao_res.orderId">查看发票详情</router-link></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div style="position: absolute; bottom: 2%; width: 100%; display: flex; justify-content: center; align-items: center">
                <a-pagination v-if="kaipiao_show == 0" show-quick-jumper :default-current="1" :total="totalPages * 10" @change="fenye_onChange" />
            </div>
        </div>
        <foot />
        <a-modal centered @cancel="visible_shouhuo = false" :visible="visible_shouhuo" :footer="null" :width="480" :height="240">
            <div class="pop_title">我确认已收到货</div>
            <div style="overflow: hidden; width: 50%; margin: 20px auto">
                <div class="pop_left_bue" @click="_querenshouhuo" style="cursor: pointer">确定</div>
                <div class="pop_left_bue" @click="visible_shouhuo = false" style="float: right; border: 1px solid #ede9e9; color: #666; background: #fff; cursor: pointer">取消</div>
            </div>
            <div class="pop_tisp">* 请收到货后，再确认收货! 如果您想申请售后，<span style="color: #2b9a34; cursor: pointer" @click="dindan_shouhuo(shouhuo_obj)">请点击这里</span></div>
        </a-modal>
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'Order',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            totalPages: 1, //总页数
            shouhuo_obj: '', //待收货订单数据
            visible_shouhuo: false, //确认收货弹框
            fapiao_list_show: true, //是否显示发票列表
            top_navs: [
                {
                    txt: '全部订单',
                    status: ''
                },
                {
                    txt: '待审核',
                    status: 'PENDING_AUDIT',
                    count: 0
                },
                {
                    txt: '待付款',
                    status: 'PENDING_PAYMENT',
                    count: 0
                },
                {
                    txt: '待发货',
                    status: 'PENDING_SHIPMENT',
                    count: 0
                },
                {
                    txt: '待收货',
                    status: 'SHIPPED',
                    count: 0
                },
                {
                    txt: '已取消',
                    status: 'CANCELED'
                },
                {
                    txt: '已完成',
                    status: 'COMPLETED'
                },
                {
                    txt: '退/换订单',
                    status: 'PENDING_REFUND'
                },
                {
                    txt: '可开票订单',
                    status: 'KEKAIPIAO'
                }
            ], // 顶部切换所有状态
            visible: false, //弹框
            order_active_index: 0, //顶部切换索引
            page: 0, //页码
            search: '', //搜索内容
            order_list: [], //订单列表

            // 发票相关的数据
            kaipiao_show: 0, //视图切换 0 订单列表 1 开票视图 2 开票成功
            invoice_information_index: 0, // 0 增值税普通发票 1 增值税专项发票
            ticket_collection_index: 0, // 0 电子发票 1 邮寄纸质发票
            kaipiao_order: [], //待开票的订单集合
            my_fapiao: [], //我的发票资料 专票和普票
            user_invoice_receive: {
                ELECTRONIC: [], //电子
                PAPER: [] //纸质
            }, //获取我的发票接收方式列表
            morenfapiao: '', //默认发票
            fapiao_res: {}, //返回的开票成功的信息
            storelist: [],
            list_invoice: [],
            id: ''
        };
    },
    filters: {
        orderStatusStr(value) {
            switch (value) {
                case 'PENDING_PAYMENT':
                    return '待付款';
                case 'PENDING_SHIPMENT':
                    return '待发货';
                case 'SHIPPED':
                    return '已发货';
                case 'RECEIVED':
                    return '已收货';
                case 'OFFLINE_PAID':
                    return '离线付款';
                case 'COMPLETED':
                    return '已完成';
                case 'CANCELED':
                    return '已取消';
                case 'PENDING_REFUND':
                    return '待退款';
                case 'PAYMENT_OFFLINE_WAITING_COLLECTION':
                    return '线下付款等待收款';
                case 'PENDING_AUDIT':
                    return '待审核';
                case 'AFTER_SALE':
                    return '退/换订单';
                case 'RETURN_RECEIVED':
                    return '退货已收到';
                case 'REFUND':
                    return '退款';
                default:
                    return '未定义';
            }
        },
        moneyStr(value) {
            value = value ? value / 100 : 0;
            return '￥' + value.toFixed(2);
        }
    },
    computed: {
        listInvoiceShow() {
            return this.list_invoice.filter(i => {
                let str = this.ticket_collection_index ? 'PAPER' : 'ELECTRONIC';
                return i.types === str;
            });
        }
    },
    methods: {
        zukf(e) {
            let userId = JSON.parse(localStorage.getItem('user_info'));
            let orderId = e.uuid;
            let storeId = e.storeId;
            this.api.isOpen(storeId).then(res => {
                if (res.ok == true) {
                    window.open(`/cus/#/client?storeId=${storeId}&entranceId=184d9ab5-cfd8-473d-bd19-064a868287b7&userId=${userId.uuid}&orderId=${orderId}`);
                    let list = {
                        storeId: orderId,
                        userId: orderId
                    };
                    this.api.tiaozhuan(list).then(res => {});
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        quxiao_order(item) {
            console.log(item);
            this.$confirm({
                title: '是否取消该售后退换申请订单',
                onOk: () => {
                    this.api.get_quxiao(item.uuid).then(res => {
                        if (res.ok) {
                            this.get_my_orders();
                            this.$message.info(res.message);
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            });
        },
        chakan_fapiao(e) {
            this.$router.push('/invoice_details?uuid=' + e.uuid);
        },
        tiao(e) {
            this.$router.push(`/goods_details?uuid=${e.productId}&storeId=${e.storeId}`);
            // this.$router.push('/goods_details?uuid=' + e.productId);
        },
        setInvoiceDefaul(index) {
            const item = this.listInvoiceShow[index];
            const data = { ...item };
            data.defaults = true;
            this.api.add_user_invoice_receive(data).then(res => {
                if (res.ok) {
                    this.$message.success(res.message);
                    this.list_invoice.forEach(i => (i.defaults = false));
                    item.defaults = true;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        checkInvoice(index) {
            this.listInvoiceShow.forEach(i => {
                i.is_check = false;
            });
            this.listInvoiceShow[index].is_check = true;
        },
        editInvoice(id) {
            this.$router.push(`/add_ticket_collection_method?uuid=${id}`);
        },
        getOrderCount() {
            this.api.ordersMyStats().then(res => {
                this.top_navs[1].count = res.data.pendingAudit;
                this.top_navs[2].count = res.data.pendingPayment;
                this.top_navs[3].count = res.data.pendingShipment;
                this.top_navs[4].count = res.data.pendingReceive;
            });
        },
        toRefund(id) {
            this.$router.push(`/refund?uuid=${id}`);
        },
        toRefundDetail(id) {
            this.$router.push(`/refund_details?uuid=${id}`);
        },
        // 右侧下拉切换订单类型
        dindan_handleChange(value) {
            //alert(value)
            this.id = value;
            this.get_my_orders(this.id);
            // if(e == '可开票订单') {
            //   this.order_active_index = 7
            //   console.log(this.order_active_index);
            //   this.get_my_orders()
            // }else if(e == '全部订单') {
            //   this.order_active_index = 0
            //   this.get_my_orders()
            // }
        },
        // 确认收货
        _querenshouhuo() {
            const that = this;
            that.api
                .order_received({
                    id: that.shouhuo_obj.uuid
                })
                .then(res => {
                    if (res.ok) {
                        that.$message.success(res.message);
                        that.get_my_orders();
                        that.visible_shouhuo = false;
                    } else {
                        that.$message.error(res.message);
                    }
                });
        },
        // 订单售后
        dindan_shouhuo(e) {
            this.$router.push('/refund?uuid=' + e.uuid);
        },
        // 单个订单点击申请开票
        dindan_kaipiao(e) {
            this.kaipiao_order[0] = e;
            if (this.my_fapiao[0] === null || this.my_fapiao[1] === null) {
                this.$message.error('请填写发票抬头信息');
                this.$router.push('/control_over_invoices');
            }
            this.get_user_invoice();
        },
        // 确认提交开票
        submitInvoice(index) {
            const item = this.listInvoiceShow.find(i => i.is_check);
            if (!item) {
                return this.$message.error('请选择收票方式');
            }

            this.$confirm({
                title: '确定开票吗?',
                onOk: () => {
                    this.api
                        .user_order_add_invoice({
                            orderId: this.kaipiao_order[0].uuid, //订单ID
                            userInvoiceId: this.my_fapiao[this.invoice_information_index].uuid, //发票ID
                            userInvoiceReceiveId: item.uuid //收票方式ID
                        })
                        .then(res => {
                            if (res.ok) {
                                this.$message.success(res.message);
                                this.fapiao_res = res.data;
                                this.kaipiao_show = 2;
                            } else {
                                this.$message.error(res.message);
                            }
                        });
                }
            });
        },
        // 设置默认
        shezhimoren(e) {
            const that = this;
            let obj = e;
            that.$confirm({
                title: `设置为默认吗?`,
                onOk() {
                    that.api.add_user_invoice_receive(obj).then(res => {
                        if (res.ok) {
                            that.$message.success(res.message);
                            that.get_user_invoice_receive();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 删除
        shanchu(e) {
            const that = this;
            that.$confirm({
                title: `确定删除吗?`,
                onOk() {
                    that.api.delete_user_invoice_receive(e).then(res => {
                        if (res.ok) {
                            that.$message.success(res.message);
                            that.get_user_invoice_receive();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 切换单选
        dianzifapiao(e, index) {
            if (index == 0) {
                // 电子切换
                this.user_invoice_receive.ELECTRONIC.forEach((element, _index) => {
                    element.active = false;
                });
            } else if (index == 1) {
                // 纸质切换
                this.user_invoice_receive.PAPER.forEach((element, _index) => {
                    element.active = false;
                });
            }
        },
        // 获取我的发票接收方式列表
        get_user_invoice_receive() {
            this.user_invoice_receive.ELECTRONIC = [];
            this.user_invoice_receive.PAPER = [];
            this.api.get_user_invoice_receive().then(res => {
                if (res.ok) {
                    if (!res.data.length) {
                        this.$confirm({
                            title: '请先添加发票信息',
                            onOk: () => {
                                this.$router.push('/control_over_invoices');
                            }
                        });
                        return;
                    }
                    res.data.forEach(i => {
                        i.is_check = false;
                        if (i.defaults) {
                            i.is_check = true;
                            if (i.types === 'PAPER') this.ticket_collection_index = 0;
                        }
                    });
                    this.list_invoice = res.data;
                    this.kaipiao_show = 1;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 我的发票资料 专票和普票
        get_user_invoice() {
            this.api.get_user_invoice('GENERAL').then(res => {
                if (res.ok) {
                    this.my_fapiao[0] = res.data; //普票
                } else {
                    this.$message.error(res.message);
                }
            });
            this.api.get_user_invoice('DEDICATED').then(res => {
                if (res.ok) {
                    this.my_fapiao[1] = res.data; //专票
                } else {
                    this.$message.error(res.message);
                }
            });
            this.get_user_invoice_receive();
        },
        // 切换发票方式
        _invoice_information_index(e) {
            if (this.my_fapiao[e] === null) {
                this.$message.error('请完善增值税专用发票信息');
            } else {
                this.invoice_information_index = e;
            }
            if (e === 1) {
                this.ticket_collection_index = 1;
            }else if(e === 0){
                this.ticket_collection_index = 0;

            }
        },
        _ticket_collection_index(e) {
            // if (this.invoice_information_index === 1) {
            //   this.ticket_collection_index = 1;
            // }
            this.ticket_collection_index = e;
        },
        // 选中单个开票订单
        item_kaipiao(index) {
            this.order_list[index].kaipiao_code = !this.order_list[index].kaipiao_code;
        },
        // 选择开票点击下一步
        _kaipiao_xiayibu() {
            /*
                                this.kaipiao_order[0] = e
                  this.kaipiao_show = 1
                  this.get_user_invoice()
                  this.get_user_invoice_receive()
                */
            this.kaipiao_order = [];
            this.order_list.forEach(element => {
                if (element.kaipiao_code) {
                    this.kaipiao_order.push(element);
                }
            });
            this.kaipiao_show = 1;
            this.get_user_invoice();
            this.get_user_invoice_receive();
        },
        // 开票全选
        kaipiao_quanxuan(e) {
            let order_list = this.order_list;
            order_list.forEach(element => {
                // 添加左侧开票多选按钮
                element.kaipiao_code = e == 0 ? false : true;
            });
            this.order_list = order_list;
        },
        // 切换右侧全部订单
        handleChange(e) {
            console.log(e);
        },
        // 去订详情
        to_order_details(e) {
            this.$router.push('/pay_to?uuid=' + e.uuid);
        },
        // 订单操作
        dindancaozuo(e) {
            if (e.orderStatus == 'PENDING_PAYMENT') {
                // 待付款 去付款也
                this.$router.push('/credit_pay?uuid=' + e.uuid);
            }
            if (e.orderStatus == 'SHIPPED') {
                // 待收货
                this.shouhuo_obj = e;
                this.visible_shouhuo = true;
            }
        },
        // 翻页
        fenye_onChange(e) {
            this.page = e - 1;
            this.get_my_orders();
        },
        // 监听搜索
        onSearch(e) {
            this.search = e;
            this.get_my_orders();
        },
        // 订单列表
        get_my_orders(id) {
            const data = {
                size: 10,
                page: this.page,
                search: this.search,
                status: this.top_navs[this.order_active_index].status,
                storeId: this.id
            };
            if (id) {
                data.storeId = id;
            }
            if (data.status === 'PENDING_REFUND') {
                data.status = '';
                data.afterSale = 'true';
            }
            if (data.status === 'COMPLETED') {
                data.status = 'COMPLETED';
            }
            if (data.status === 'KEKAIPIAO') {
                data.status = '';
                data.canInvoice = true;
            }
            // KEKAIPIAO
            this.api.get_my_orders(data).then(res => {
                if (res.ok) {
                    this.order_list = res.data.content;
                    this.totalPages = res.data.totalPages;
                    this.order_list.forEach(element => {
                        // 添加左侧开票多选按钮
                        element.kaipiao_code = false;
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        get_store() {
            this.api.purchase_store({}).then(res => {
                if (res.ok) {
                    this.storelist = res.data;
                } else {
                }
            });
        },
        // 切换订单类型
        chang_order_state(e) {
            this.kaipiao_show = 0;
            this.order_active_index = e;
            this.fenye_onChange(1);
        },
        //从首页图片跳转
        get_home() {
            if (this.$route.query.id) {
                this.chang_order_state(this.$route.query.id);
            }
        }
    },
    created() {
        this.getOrderCount();
        this.get_store();
        this.get_my_orders();
        this.get_home();
    }
};
</script>

<style scoped>
.siderbarTitle {
    display: inline-block;
    width: 80px;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.siderbarTitle:hover {
    overflow: visible;
    animation: 3s siderbar linear infinite normal;
    z-index: 0;
}
/* @keyframes siderbar {
    0% {
        transform: translateX(0);
        -webkit-transform: translateX(0);
    }
    100% {
        transform: translateX(-45px);
        -webkit-transform: translateX(-45px);
    }
} */
.table-invoice {
    margin: 20px 0;
    width: 100%;
}
.table-invoice tr {
    border-bottom: 1px solid #ccc;
}
.table-invoice tr:first-child {
    background: #f4f4f4;
    border: none;
}
.table-invoice td {
    padding-left: 11px;
    line-height: 40px;
}
.table-invoice td:first-child {
    width: 40px;
    text-align: center;
}
.table-invoice td:nth-child(2) {
    width: 160px;
}
.table-invoice td:nth-child(3) {
    width: 200px;
}
.table-invoice td:last-child {
    text-align: right;
}
.table-invoice input {
    vertical-align: middle;
}
.table-invoice td > span {
    margin-right: 20px;
    font-size: 12px;
    color: #2b9a34;
    cursor: pointer;
}
.table-invoice td > span.active {
    padding: 5px 9px;
    background: #f24145;
    color: white;
}

.tiao:hover {
    cursor: pointer;
}

.select-shop {
    float: right;
    margin-right: 20px;
    margin-top: 24px;
    width: 200px;
    height: 32px;
}
.search {
    float: right;
    margin-top: 24px;
    width: 360px;
}
/deep/ .search button {
    height: 32px;
}
#order {
    color: #333;
}
/* 订单 */
.display {
    min-width: 850px;
    display: flex;
    justify-content: space-between;
    color: #2b9a34;
}
.item-header {
    display: flex;
    margin-top: 20px;
    padding-left: 20px;
    line-height: 40px;
    color: rgb(255, 255, 255);
    background: #2b9a34;
}
.item-header span:first-child {
    width: 520px;
}
.item-header span:nth-child(2) {
    width: 110px;
}
.item-header span:nth-child(3) {
    width: 190px;
}
.item-header span:nth-child(4) {
    width: 90px;
}
.item-header span:nth-child(5) {
    width: 90px;
}
.item-content {
    display: flex;
}
.item-content > div {
    border-right: 1px solid #ede9e9;
}
.item-content > div:nth-child(2),
.item-content > div:nth-child(3) {
    padding-top: 20px;
}
.item-content > div:first-child {
    flex: 1;
}
.item-content > div:nth-child(2) {
    width: 260px;
}
.item-content > div:last-child {
    display: flex;
    width: 218px;
    border-right: none;
}
.item-content > div:last-child > div:first-child {
    width: 130px;
    text-align: center;
}
.item-content > div:last-child > div:last-child > div {
    margin-bottom: 10px;
    cursor: pointer;
}
.item-goods {
    display: flex;
    padding-left: 20px;
    border-bottom: 1px solid #ede9e9;
}
div > .item-goods:last-child {
    border: none;
}
.item-goods > span:nth-child(1) {
    width: 50px;
}
.item-goods > span:nth-child(2),
.item-goods > span:nth-child(3) {
    flex: 1;
}
.item-goods > span:nth-child(4) {
    width: 100px;
}
.item-goods > span:nth-child(5) {
    width: 100px;
}
.item-goods > span:nth-child(6) {
    width: 110px;
    color: #f24145;
}
.item-goods > span:nth-child(7) {
    width: 110px;
    color: #f24145;
}
.kaipiaochengon_txt1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.kaipiaochengon_txt {
    float: left;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-left: 20px;
    margin-top: 10px;
}

.zengzhishui_txt {
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 17px;
}

.tijiaofapiao {
    float: right;
    margin-top: 20px;
    margin-bottom: 74px;
    text-align: center;
    width: 100px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    border: 1px solid #2b9a34;
    cursor: pointer;
}

.fapiaoxiangqing_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
}

.fapiaoxiangqing_txt1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
}

.goods_left_item {
    height: 100px;
    line-height: 100px;
    /* border-bottom: 1px solid #EDE9E9; */
    border-right: 1px solid #ede9e9;
}

.pop_tisp {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin-top: 20px;
}

.pop_left_bue {
    width: 100px;
    height: 40px;
    background: #2b9a34;
    float: left;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
}

.pop_title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
    text-align: center;
}

.querenshouh {
    width: 60px;
    height: 24px;
    border: 1px solid #2b9a34;
    cursor: pointer;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    text-align: center;
    line-height: 24px;
}

.order_item_time {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    float: right;
}
.order_item_title1 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
}
.order_item_title {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
}

.order_box {
    width: 100%;
    border: 1px solid #ede9e9;
}

.order_boxs {
    width: 100%;
    border-left: 1px solid #ede9e9;
    border-right: 1px solid #ede9e9;
    border-bottom: 1px solid #ede9e9;
    display: flex;
    justify-content: space-between;
    font-size: 13px;
}

.head_items {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: left;
    width: 11.111%;
    float: left;
    cursor: pointer;
    text-align: center;
    padding: 0 15px;
    margin-top: 5px;
}
.head_items span {
    color: #2b9a34;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box61 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    min-height: 1023px;
    width: 963px;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 0 20px;
    padding-bottom: 20px;
    min-height: 1023px;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}

.active {
    color: #2b9a34;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.fapiaotaitou {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
}

.zengzhishui {
    width: 140px;
    height: 40px;
    border: 1px solid #ede9e9;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    line-height: 40px;
    float: left;
    cursor: pointer;
}
/* 选择发票方式 */

.fapiao_actiive {
    border-color: #2b9a34;
}
/* 是否显示左边的选择按钮 */

.left_order_active {
    float: right;
    /* width: 95%; */
}
/* 开票下一步按钮 */

.kaipiao_xiayibu {
    width: 100px;
    height: 40px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    cursor: pointer;
    float: right;
}
/* 默认发票样式 */

.moren_box {
    background: #f24246;
    color: #fff !important;
    width: 90px;
    height: 26px;
    background: #f24246;
    line-height: 26px !important;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-top: 15px !important;
    text-align: center;
}
/* 发票列表样式 */

.fapial_list_item {
    height: 40px;
    float: left;
    border-right: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}

.table_head_txt {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: center;
    line-height: 43px;
    cursor: pointer;
}

.shouqifapiao {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/order.vue